/* esm.sh - micromark-extension-gfm-strikethrough@2.1.0 */
export * from "/*micromark-extension-gfm-strikethrough@2.1.0/esnext/micromark-extension-gfm-strikethrough.mjs";
